var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Transition", { attrs: { name: "video-toast" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "video-toast",
            class: `video-toast--${_vm.toast.kind}`,
            attrs: { role: "status" },
          },
          [_vm._v(" " + _vm._s(_vm.text) + " ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }